import { render, staticRenderFns } from "./WriteDataItem.vue?vue&type=template&id=2ac8a568&scoped=true&"
import script from "./WriteDataItem.vue?vue&type=script&lang=js&"
export * from "./WriteDataItem.vue?vue&type=script&lang=js&"
import style0 from "./WriteDataItem.vue?vue&type=style&index=0&id=2ac8a568&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac8a568",
  null
  
)

export default component.exports